import React,{Component} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

class UserSurvey extends Component {
    
    render() {
        return <Paper>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className="width50pct">
                            Questions
                        </TableCell>
                        <TableCell className="width50pct">
                            Answers
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.props.account.employer.survey.map((question,index)=><TableRow key={`question-${index}`}>
                        <TableCell>
                            <b>{question.name}</b>
                        </TableCell>
                        <TableCell>
                            {(this.props.account.survey.hasOwnProperty(`option_${question.id}`)&&this.props.account.survey[`option_${question.id}`]&&(this.props.account.survey[`option_${question.id}`] instanceof Array?this.props.account.survey[`option_${question.id}`].join(", "):this.props.account.survey[`option_${question.id}`]))||""}
                        </TableCell>
                    </TableRow>)}
                </TableBody>
            </Table>
        </Paper>
    }
}
export default UserSurvey;